export const BASE_URL = `${process.env.REACT_APP_BASE_URL ?? "/api"}`;
export const OBJECT_URL_IGNORE_REDIRECT = {
  "/resend-email": true,
  "/email/verify": true,
};
